import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useApplication from '../contexts/Application';
import useAnswer from '../contexts/Answer';
import Markdown from './Markdown';
import Answer from './Answer';
import TestMedia from './TestMedia';


const Box = styled.div`

`;


const Application = () => {
  const { application, clearApplication } = useApplication();
  const { answer, nextAnswer } = useAnswer();
  const [status, setStatus] = useState('unknown');

  useEffect(() => {
    if (application) {
      setStatus(application.assessment.hasQuestionRecord ? 'test' : 'ready');
    }
  }, [application]);

  const handleClick = () => {
    nextAnswer();
  };

  const handleSuccess = () => {
    setStatus('ready');
  };

  return (
    <>
      {application && !answer && (
        <Box>
          <h1>{application.assessment.title}</h1>
          <Markdown value={application.assessment.description} />
          {status !== 'unknown' && <TestMedia onSuccess={handleSuccess} />}
          <div className="actions">
            <button className="plain" onClick={() => clearApplication()}>Back</button>
            {application.started && <button disabled={status !== 'ready'} className="primary" onClick={handleClick}>Continue</button>}
            {!application.started && <button disabled={status !== 'ready'} className="primary" onClick={handleClick}>Ready to Start!</button>}
          </div>
        </Box>
      )}
      <Answer />
    </>
  );
};

export default Application;
